import React from "react"
import PropTypes from "prop-types"
import DatePicker from "./wrappers/DatePicker"
import SelectField from "../OpportunitySearchFilter/wrappers/SelectField"
import KeywordsAutocomplete from "../OpportunitySearchFilter/wrappers/KeywordsAutocomplete"
import CheckboxGroup from "../../CheckboxGroup"
import { filterOptions } from "./filterConfig"
import { setValue } from "./useReducer/actionCreators"
import suggestionServices from "../../../services/suggestionServices"
import styles from "./index.module.scss"

const CoreFilters = ({ values, dispatch }) => {
  const set = (name) => (value) => dispatch(setValue(name, value))
  // Two columns filled row by row, so the paired fields line up; the audience list and the
  // date range use the full width.
  return (
    <div className={styles.coreGrid}>
      <div className={styles.item}>
        <SelectField
          id="filter_resource_type"
          label="Resource Type"
          options={filterOptions.resourceType}
          value={values.resourceType}
          onChange={set("resourceType")}
        />
      </div>
      <div className={styles.item}>
        <KeywordsAutocomplete
          value={values.keywords}
          onChange={set("keywords")}
          getSuggestions={suggestionServices.getResourceKeywords}
          placeholder="Topic or keyword"
        />
      </div>
      <div className={styles.fullRow}>
        <CheckboxGroup
          id="filter_audience"
          label="Audience"
          options={filterOptions.audience}
          values={values.audience}
          onChange={set("audience")}
          collapseAfter={null}
          columns={2}
        />
      </div>
      <div className={styles.item}>
        <SelectField
          id="filter_access_type"
          label="Access"
          options={filterOptions.accessType}
          value={values.accessType}
          onChange={set("accessType")}
        />
      </div>
      <div className={styles.item}>
        <SelectField
          id="filter_resource_format"
          label="Format"
          options={filterOptions.resourceFormat}
          value={values.resourceFormat}
          onChange={set("resourceFormat")}
        />
      </div>
      <div className={styles.fullRow}>
        <DatePicker
          title="Date Published"
          fromDate={values.fromDate}
          toDate={values.toDate}
          externalDispatch={dispatch}
        />
      </div>
    </div>
  )
}

CoreFilters.propTypes = {
  values: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
}

export default CoreFilters
